import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import DatePicker from 'components/Date/DatePicker';
import moment from 'moment';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'applicationDt', label: '신청일자', minWidth: 100, align: 'center' },
  { id: 'dueDate', label: '만료일자', minWidth: 100, align: 'center' },
  { id: `User.username`, label: '담당자명', minWidth: 140, align: 'center' },
  { id: `User.Company.companyName`, label: '회사명', minWidth: 100, align: 'center' },
  { id: 'clientKey', label: '사용자키', minWidth: 100, align: 'center' },
  { id: 'activeCode', label: '활성화코드', minWidth: 180, align: 'center' },
  { id: 'requestName', label: '요청자명', minWidth: 180, align: 'center' },
  { id: 'isAble', label: '활성화 여부', minWidth: 180, align: 'center' }
];

export default function AdminActiveCodeMng() {
  const date = new Date();
  const [srchData, setSrchData] = useState({
    startYmd: moment(date.getTime()).add('-1', 'y'),
    endYmd: moment()
  });
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [open, setOpen] = useState(false);

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const getDataList = async (e) => {
    const { startYmd, endYmd, username, companyNo, companyName } = srchData;
    if (!!!startYmd) {
      alert('발급 시작일을 입력해 주세요.');
      return;
    }
    if (!!!endYmd) {
      alert('발급 종료일을 입력해 주세요.');
      return;
    }

    let params = {
      offset,
      page,
      limit: offset,
      startYmd,
      endYmd,
      username,
      companyNo,
      companyName
    };

    const response = await axios.get(`/api/active`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  useEffect(() => {
    getDataList(page);
  }, [page]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        활성화 코드 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item sx={{ width: '100%' }}>
          <Stack direction="row" spacing={2}>
            <DatePicker
              format={'yyyy-MM-DD'}
              label="발급 시작일"
              value={srchData.startYmd}
              onChange={(newValue) => {
                setSrchData({ ...srchData, startYmd: newValue });
              }}
              renderInput={(params) => <TextField {...params} helperText={null} />}
              disableMaskedInput={true}
            />
            <DatePicker
              format={'yyyy-MM-DD'}
              label="발급 종료일"
              value={srchData.endYmd}
              onChange={(newValue) => {
                setSrchData({ ...srchData, endYmd: newValue });
              }}
              renderInput={(params) => <TextField {...params} helperText={null} />}
              disableMaskedInput={true}
            />
            <TextField id="companyNameSrch" variant="outlined" label="회사명" value={srchData?.companyName || ''} onChange={handleChangeSrch} />
            <TextField id="companyNoSrch" variant="outlined" label="사업자등록번호" value={srchData?.companyNo || ''} onChange={handleChangeSrch} />
            <TextField id="usernameSrch" variant="outlined" label="담당자명" value={srchData?.username || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id}>
                    {columns.map((col, colIdx) => {
                      if (col.id === 'isAble') {
                        if (row.disableComment) {
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              차단
                            </TableCell>
                          );
                        } else {
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              활성화
                            </TableCell>
                          );
                        }
                      } else {
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {col.id.split('.').length != 1
                              ? col.id.split('.').length == 2
                                ? eval('row.' + col.id.split('.')[0])[col.id.split('.')[1]]
                                : eval('row.' + col.id.split('.')[0] + '.' + col.id.split('.')[1])[col.id.split('.')[2]]
                              : row[col.id]}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
      </Grid>
    </Paper>
  );
}
